import { EXPEDIENT_WEEK_DAYS } from "../constants";
import type { ExpedientDayApiItem, ExpedientDayForm } from "../types";

export function toDisplayTime(timeValue: string | null): string {
	const value = (timeValue ?? "").trim();
	if (!value) return "";
	if (/^\d{2}:\d{2}$/.test(value)) return value;
	if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value.slice(0, 5);
	return "";
}

export function toApiTime(timeValue: string): string {
	const value = timeValue?.trim() ?? "";
	if (!value) return "";
	if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value;
	if (/^\d{2}:\d{2}$/.test(value)) return `${value}:00`;
	return "";
}

export function mapApiDaysToForm(
	days: ExpedientDayApiItem[]
): ExpedientDayForm[] {
	return EXPEDIENT_WEEK_DAYS.map((weekDay) => {
		const foundDay = days.find((item) => item.day === weekDay.day);
		if (foundDay) {
			return {
				day: foundDay.day,
				startTime: toDisplayTime(foundDay.startTime),
				endTime: toDisplayTime(foundDay.endTime),
				isActive: foundDay.isActive,
			};
		}
		return { day: weekDay.day, startTime: "", endTime: "", isActive: false };
	});
}

export function getActiveScheduleRows(
	days: ExpedientDayForm[]
): { day: string; schedule: string }[] {
	return EXPEDIENT_WEEK_DAYS.map((weekDay) => {
		const foundDay = days.find((item) => item.day === weekDay.day);
		const isActive = foundDay?.isActive ?? false;
		const hasTime = !!(foundDay?.startTime && foundDay?.endTime);
		const schedule =
			isActive && hasTime ? `${foundDay.startTime} - ${foundDay.endTime}` : "";
		return { day: weekDay.label, schedule };
	}).filter((row) => row.schedule !== "");
}

export function validateSchedule(
	days: ExpedientDayForm[]
): Partial<Record<number, string>> {
	const errors: Partial<Record<number, string>> = {};
	for (const day of days) {
		if (!day.isActive) continue;
		if (!(day.startTime && day.endTime)) {
			errors[day.day] = "Preencha início e fim para este dia.";
			continue;
		}
		if (day.startTime >= day.endTime) {
			errors[day.day] =
				"O horário de início deve ser menor que o horário de fim.";
		}
	}
	return errors;
}

export function mapFormToApiPayload(days: ExpedientDayForm[]): Array<{
	day: number;
	startTime: string | null;
	endTime: string | null;
	isActive: boolean;
}> {
	return days.map((item) => ({
		day: item.day,
		startTime: item.isActive ? toApiTime(item.startTime) : null,
		endTime: item.isActive ? toApiTime(item.endTime) : null,
		isActive: item.isActive,
	}));
}
